import React, { memo } from 'react'
import { LntImage, LntSpin } from '@app/components/base'

import { useImageLoadingState } from './hooks'

import type { ImageRendererProps } from './types'

const DEFAULT_FALLBACK_MESSAGE = 'Ошибка загрузки картинки'

const Component: React.FC<ImageRendererProps> = ({
  fallbackContent = DEFAULT_FALLBACK_MESSAGE,
  src,
  ...imageProps
}) => {
  const { isLoading, isError } = useImageLoadingState(src)

  if (isLoading) return <LntSpin spinning />

  if (isError) return <div>{ fallbackContent }</div>

  return (
    <LntImage
      src={ src }
      { ...imageProps }
    />
  )
}

export const ImageRenderer = memo(Component)
